import { Banknote, RotateCcw, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useStoreConfig } from "../../features/config/queries";

export function ProductDeliveryInfo({
  isReturnable,
  productName,
  productUrl
}: {
  isReturnable: boolean;
  productName: string;
  productUrl: string;
}) {
  const { data: config } = useStoreConfig();
  const whatsappNumber = config?.whatsappNumber?.replace(/[^\d]/g, "");
  const inquiryMessage = encodeURIComponent(`Hi! I'm interested in "${productName}" — ${productUrl}`);

  return (
    <div className="rounded-2xl border border-border bg-surface divide-y divide-border">
      <div className="flex items-start gap-3 p-4">
        <Banknote size={18} className="text-accent shrink-0 mt-0.5" aria-hidden />
        <div>
          <p className="text-sm font-medium">Cash on delivery</p>
          <p className="text-xs text-ink-muted mt-0.5">A small advance confirms your order — the rest is paid on delivery.</p>
        </div>
      </div>
      <div className="flex items-start gap-3 p-4">
        <RotateCcw size={18} className="text-accent shrink-0 mt-0.5" aria-hidden />
        <div>
          <p className="text-sm font-medium">{isReturnable ? "Easy returns" : "Final sale"}</p>
          <p className="text-xs text-ink-muted mt-0.5">
            {isReturnable ? (
              <>
                Not right? Send it back on eligible items.{" "}
                <Link to="/returns" className="text-accent hover:underline">
                  See return policy
                </Link>
              </>
            ) : (
              "This item isn't eligible for return or exchange."
            )}
          </p>
        </div>
      </div>
      {whatsappNumber && (
        <a
          href={`https://wa.me/${whatsappNumber}?text=${inquiryMessage}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-start gap-3 p-4 hover:bg-surface-raised transition-colors duration-300"
        >
          <MessageCircle size={18} className="text-accent shrink-0 mt-0.5" aria-hidden />
          <div>
            <p className="text-sm font-medium">Have a question?</p>
            <p className="text-xs text-ink-muted mt-0.5">Ask us about this product on WhatsApp.</p>
          </div>
        </a>
      )}
    </div>
  );
}
